import { BoxConsumableStatus } from "@modules/boxConsumable/entities/boxConsumableType"
import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import { BoxOfferDetailedDtoSchema } from "@modules/boxOffer/gateway/boxOfferDto"
import { CouponDtoSchema } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { LightPromoCodeDtoSchema } from "@modules/promoCode/services/promoCodeDto"
import { z } from "zod"

export const BoxConsumableDetailsDtoSchema = z.object({
  id: z.string(),
  type: z.nativeEnum(BoxOfferType),
  creationDate: z.string().datetime(),
  endValidity: z.string().datetime().nullable(),
  status: z.nativeEnum(BoxConsumableStatus),
  count: z.number().nullable(),
  referencePrice: PriceObjectDtoSchema.nullable(),
  priceObject: PriceObjectDtoSchema.nullable(),
  usedPromoCode: LightPromoCodeDtoSchema.nullable(),
  coupon: CouponDtoSchema.nullable(),
  offer: BoxOfferDetailedDtoSchema,
})

export type BoxConsumableDetailsDto = z.infer<typeof BoxConsumableDetailsDtoSchema>
